import React, { useState, useEffect } from 'react'

import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'
import Gender from './GenderAge'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import SystemNotifications from './SystemNotifications'
import CovidMap from './CovidMap'
import FluMap from './FluMap'
import HrrMap from './HRRMap'
import RSVMap from './RSVMap'
import AllergiesMap from './AllergiesMap'
import VulnerabilityMap from './VulnerabilityMap'
import BottomGraphPanel from './BottomGraphPanel'
import RiskPredictorPanel from './RiskPredictorPanel'
import RaceEthnicityGraph from '../RaceEthnicity'
import EmptyMap from '../../components/Map/emptyMap'
import styles from './Dashboard.module.scss'
import DashboardHeader from './DashboardHeader'
import { useAuthState } from '../../components/AuthProvider'
import activityLog from '../../utils/activityLog'
import GeoProvider from '../../components/GeoProvider'
import dataDisplayOptions from '../CovidPharma/dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'

const Dashboard = () => {
  const [errorOccured, seterrorOccured] = useState(false)

  const history = useHistory()
  const [getStateJsonFile, setStateJsonFile] = useState()

  const [getfilterts, filtersObj] = useState({
    type: 'All',
    lob: 'All',
    season: '12',
    month: 'All',
  })
  const [getMemberVaccinated, setMemberVaccinated] = useState({
    MemberVaccinated: '0M',
  })

  const { user } = useAuthState()

  var logObject = {
    dashboard_url: window.location.href,
    dashboard_name: 'Dashboard',
    indicator_name: 'Dashboard',
    geo_name: '',
    geo_type: '',
    user_name: user.username,
    email: user.email,
  }

  useEffect(() => {
    activityLog(logObject)
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        // console.log(data)
        setStateJsonFile(data)
      })
      .catch(function (err) {
        console.log(err, ' error file load usStatesAll ')
      })
  }, [1])
  const [getJsonData, setJsonData] = useState()
  useEffect(() => {
    let url = `${window.location.origin}/us_hrr_values.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        // console.log(data)
        setJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file load us_hrr_values ')
      })
  }, [1])
  if (errorOccured) {
    return (
      <Layout>
        <Content></Content>
      </Layout>
    )
  }

  return (
    <Layout>
      <Content>
        <SystemNotifications />
        <DashboardHeader />
        <div className={styles.base}>
          <div className={styles.rsvPanel}>
            <div className={styles.dashboardCard}>
              <div className={styles.dashboardCardHeader}>
                <div className={styles.mapHeaderDiv}>
                  <span className={styles.mapName}>RSV Incidence</span>
                </div>
              </div>

              <GeoProvider
                startDate={startDate}
                endDate={endDate}
                displayDate={displayDate}
                mapOptions={dataDisplayOptions[0]['options'][0]}
                regionSelected={'state'}
              >
                {' '}
                <RSVMap />
              </GeoProvider>
            </div>
          </div>
          {/* <div className={styles.vulPanel}
                style={{ display: user.role === 'External' ? 'none' : 'block' }}
              >
                <a
                  href=""
                  onClick={() => {
                    history.push('/forecasts/vulnerabilitydashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Vulnerability</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={'October 2023'}
                      mapOptions={dataDisplayOptions[0]['options'][1]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <VulnerabilityMap />
                    </GeoProvider>
                  </div>
                </a>
              </div> */}
          <div className={styles.fluPanel}>
            <div className={styles.dashboardCard}>
              <div className={styles.dashboardCardHeader}>
                <div className={styles.mapHeaderDiv}>
                  <span className={styles.mapName}>Influenza Level</span>
                </div>
              </div>
              <>
                <div id="fluMap">
                  <FluMap staticStateJson={getStateJsonFile} />
                </div>
              </>
              <div              
                className={styles.sourceDiv}
                style={{padding: '0px', position: 'absolute', bottom: '10px', left: '5px' }}
              >
                <span className={styles.mapHeaderDiv}>
                  <span> Source : Medical Claims Data</span>
                </span>
              </div>
            </div>
          </div>
          <div className={styles.covidPanel}>
            <div className={styles.dashboardCard}>
              <div className={styles.dashboardCardHeader}>
                <div className={styles.mapHeaderDiv}>
                  <span>COVID-19 Incidence </span>
                </div>
              </div>
              <>
                <GeoProvider
                  startDate={startDate}
                  endDate={endDate}
                  displayDate={displayDate}
                  mapOptions={dataDisplayOptions[0]['options'][4]}
                  regionSelected={'state'}
                >
                  <CovidMap />
                </GeoProvider>
              </>

              <div className={styles.sourceDiv} style={{padding: '0px', position: 'absolute', bottom: '10px', left: '5px' }}>
                <span className={styles.mapHeaderDiv} style={{fontSize:'12px', fontWeight:'bold'}}>Source : UDW data</span>
              </div>
            </div>
          </div>

          <div className={styles.hrrPanel}>
            <div className={styles.dashboardCard}>
              <div className={styles.dashboardCardHeader}>
                <div className={styles.mapHeaderDiv}>
                  <span>COVID-19 Weekly Hospitalizations</span>
                </div>
              </div>

              {getJsonData ? (
                <>
                  <HrrMap
                    hrrdata={getJsonData}
                    staticStateJson={getStateJsonFile}
                  />
                </>
              ) : (
                <EmptyMap stateJson={getStateJsonFile} mapHeight={'40vh'} />
              )}

              <div
                style={{ position: 'absolute', bottom: '0px' }}
                className={styles.sourceDiv}
              >
                <span className={styles.mapHeaderDiv}>
                  Source : <span>Health and Human Services</span>
                </span>
              </div>
            </div>
          </div>
          {/* <div className={styles.allergyPanel}>
            <div className={styles.dashboardCard}>
              <div className={styles.dashboardCardHeader}>
                <div className={styles.mapHeaderDiv}>
                  <span>Allergies and AQ</span>
                </div>
              </div>

               <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][3]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <AllergiesMap />
                    </GeoProvider>
            </div>
          </div> */}
        </div>
        <RiskPredictorPanel />

        <div className={styles.ageGenderGraph}>
          <span className={styles.heading}>
            United States Census Bureau Population Data
          </span>
          <div className={styles.graphPanel}>
            <Gender geo_type="NAT" geo_id="NAT" />
          </div>
        </div>

        <div className={styles.raceEthnicity}>
          <RaceEthnicityGraph geo_type="NAT" geo_id="NAT" />
        </div>

        <BottomGraphPanel
          getMemberVaccinated={getMemberVaccinated}
          getfilterts={getfilterts}
        />
      </Content>
    </Layout>
  )
}

export default Dashboard
